// 封装axios
import axios from 'axios'
import {
  getToken,
  removeCompany,
  removeOaOrg,
  removeSuperGroup,
  removeToken,
  removeUserStatus,
  setRedirectUrl,
} from './cookie'
import store from '../store'
import { logout } from '../store/actions/login'
import history from './history'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { message, Spin } from 'antd'
import { getLocationOrigin } from './util'
import { urlMap } from './urlMap'
const instance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL || window.location.origin}/api/`,
  timeout: 50000,
  withCredentials: true,
})
message.config({
  maxCount: 1,
})

// 当前正在请求的数量
let requestCount = 0

// 显示loading
function showLoading() {
  if (requestCount === 0) {
    var dom = document.createElement('div')
    dom.setAttribute('id', 'loading')
    const contentDiv = document.getElementById('right_content')
    contentDiv ? contentDiv.appendChild(dom) : document.body.appendChild(dom)
    ReactDOM.render(<Spin tip="加载中..." size="large" />, dom)
  }
  requestCount++
}

// 隐藏loading
function hideLoading() {
  requestCount--
  if (requestCount === 0) {
    const contentDiv = document.getElementById('right_content');
    if(document.getElementById('loading')){
      contentDiv? contentDiv.removeChild(document.getElementById('loading'))
      : document.body?.removeChild(document.getElementById('loading'))
    }
  }
}

// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    // requestCount为0，才创建loading, 避免重复创建
    if (config.isLoading !== false) {
      showLoading()
    }
    // MCP 登录及授权自行选择凭据；其他调用保留原有 prefix 行为。
    const token = config.manualAuth ? null : getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  function (error) {
    // 判断当前请求是否设置了不显示Loading
    if (error.config?.isLoading !== false) {
      hideLoading()
    }

    return Promise.reject(error)
  }
)

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // 判断当前请求是否设置了不显示Loading
    if (response.config.isLoading !== false) {
      hideLoading()
    }
    if (response.data.code == 3 && !response.config.manualAuth) {
      removeCompany()
      // store.dispatch(logout())
      removeToken()
      removeUserStatus()
      removeSuperGroup()
      if (!urlMap.loginHtml()) {
        setRedirectUrl(window.location.href);
      }
      window.location.href = getLocationOrigin() + '/loginHtml'
    }
    if (response.data.code && response.data.code !== 0) {
      //有些接口不需要提示
      if(response.config.notMsg === true){

      } else {
        message.error(response.data.msg)
      }
    }
    if(response.config.returnData){
      return response.data
    }
    // 对响应数据做点什么
    return response
  },
  function (error) {
    if (error.config?.isLoading !== false) {
      hideLoading()
    }
    if (error.response?.status === 500 && !error.config?.manualAuth) {
      // 对响应错误做点什么
      // 网络问题
      message.error('网络繁忙，稍后重试', 3)
      // return Promise.reject(error)
    }
    if (error.response?.status === 401 && !error.config?.manualAuth) {
      removeToken()
      removeUserStatus()
      removeSuperGroup()
      removeCompany()
      removeOaOrg()
      if (!urlMap.loginHtml()) {
        setRedirectUrl(window.location.href);
      }
      window.location.href = getLocationOrigin() + '/loginHtml'
      return Promise.reject('登录信息过期，请重新登录～')
      // store.dispatch(logout())
    }

    return Promise.reject(error)
  }
)
Component.prototype.$axios = instance
export default instance
